import React from "react";

const FilterIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.52637 7H15.5264M1.77637 1.5H18.2764M7.27637 12.5H12.7764"
        stroke={color ?? "#475569"}
        strokeWidth="1.837"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FilterIcon;
